import { render, staticRenderFns } from "./EnterPackage.vue?vue&type=template&id=165a6538&scoped=true&"
import script from "./EnterPackage.vue?vue&type=script&lang=js&"
export * from "./EnterPackage.vue?vue&type=script&lang=js&"
import style0 from "./EnterPackage.vue?vue&type=style&index=0&id=165a6538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a6538",
  null
  
)

export default component.exports